import { Component, computed, input } from '@angular/core';
import { type DeviceChart } from '@devices';
import { PowerType } from '@devices/models';

import { EnergyValueComponent } from '../energy-value';

@Component({
  imports: [EnergyValueComponent],
  selector: 'avs-li-energy-consumption-widget',
  standalone: true,
  templateUrl: './energy-consumption-widget.component.html',
})
export class EnergyConsumptionWidgetComponent {
  chartData = input<DeviceChart | null>(null);

  protected energyStats = computed(() => {
    const data = this.chartData();

    if (!data || !data.timeseries?.length) {
      return this.getDefaultStats();
    }

    const rawStats = this.computeStatistics(data.timeseries);

    return [
      { name: PowerType.TOTAL, value: rawStats.total },
      { name: PowerType.AVERAGE, value: rawStats.average },
      { name: PowerType.MIN, value: rawStats.min ?? 0 },
      { name: PowerType.MAX, value: rawStats.max },
    ];
  });

  protected readonly energyStatPairs = computed(() => {
    const stats = this.energyStats();
    const pairs = [];

    for (let i = 0; i < stats.length; i += 2) {
      pairs.push(stats.slice(i, i + 2));
    }

    return pairs;
  });

  private computeStatistics(timeseries: { value: number }[]) {
    let total = 0;
    let max = 0;
    let min: number | null = null;

    timeseries.forEach(entry => {
      const value = Number(entry.value);

      total += value;
      max = Math.max(max, value);
      min = min === null ? value : Math.min(min, value);
    });

    return {
      average: total / timeseries.length,
      max,
      min,
      total,
    };
  }

  private getDefaultStats() {
    return [
      { name: PowerType.TOTAL, value: 0 },
      { name: PowerType.AVERAGE, value: 0 },
      { name: PowerType.MIN, value: 0 },
      { name: PowerType.MAX, value: 0 },
    ];
  }
}
